import { apiClient } from '@/lib/api.ts'

export function getInternalUsers() {
  return apiClient.get('/users', { params: { portalKind: 'internal' } })
}

export function createUser(data: Record<string, unknown>) {
  return apiClient.post('/users', data)
}

export function updateUser(id: string, updates: Record<string, unknown>) {
  return apiClient.patch(`/users/${id}`, updates)
}

export function deleteUser(id: string) {
  return apiClient.delete(`/users/${id}`)
}

export function getUserModules(userId: string) {
  return apiClient.get(`/users/${userId}/modules`)
}

export function setUserModules(userId: string, modules: Record<string, boolean>) {
  return apiClient.put(`/users/${userId}/modules`, { modules })
}

export function deleteUserModule(userId: string, moduleId: string) {
  return apiClient.delete(`/users/${userId}/modules/${moduleId}`)
}

export function getPermissions() {
  return apiClient.get('/permissions')
}

export function setPermissionOverride(overrides: Array<{ userId: string; resource: string; action: string; allowed: boolean }>) {
  return apiClient.put('/permissions', { overrides })
}

export function getPermissionGroups() {
  return apiClient.get('/permission-groups')
}

export function setUserPermissionGroups(userId: string, groupIds: string[]) {
  return apiClient.put(`/permission-groups/users/${userId}`, { groupIds })
}

export function getUserTenantMemberships(userId: string) {
  return apiClient.get(`/users/${userId}/tenant-memberships`)
}

export function addUserTenantMembership(userId: string, tenantId: string) {
  return apiClient.post(`/users/${userId}/tenant-memberships`, { tenantId })
}

export function updateUserTenantMembership(
  userId: string,
  tenantId: string,
  updates: { sapAccessMode?: 'none' | 'tenant' | 'own'; tanssEmployeeId?: string | null },
) {
  return apiClient.patch(`/users/${userId}/tenant-memberships/${tenantId}`, updates)
}

export function deleteUserTenantMembership(userId: string, tenantId: string) {
  return apiClient.delete(`/users/${userId}/tenant-memberships/${tenantId}`)
}

export function setUserTanssCredentials(
  userId: string,
  tenantId: string,
  data: { tanssUser: string; tanssPassword?: string; tanss2faCode?: string },
) {
  return apiClient.put(`/users/${userId}/tenant-memberships/${tenantId}/tanss-credentials`, data)
}
